import { useAuth0 } from "ct-auth"
import { useNavigate } from "react-router-dom"
import { entitlementTypes, userHasEntitlement, userOrg } from "../../../data-utils/authUtils"
import { useOrganizationApis } from "../../../data-utils/organizationUtils"
import { BUILDER_FEATURE_URL, ROUTE_PATHS } from "../../../utilities/constants"
import "./Home.scss"

// Same gate as the Scenarios page's "+ Build": an org without the Scenario Builder entitlement
// (e.g. a partner org it was stripped from) gets no shortcut into the builder. Its own component so
// the org lookup only runs where the button can appear.
function BuildScenarioButton({ onClick }) {
  const { user } = useAuth0()
  const { data: userOrgData = null } = useOrganizationApis.ORG_DETAIL(userOrg(user))
  if (!BUILDER_FEATURE_URL || !userHasEntitlement({ user, org: userOrgData, entitlementType: entitlementTypes.SCENARIO_BUILDER })) return null
  return (
    <button className="btn btn-primary btn-filled me-1" onClick={onClick}>
      <span className="me-2">
        <i className="fa-solid fa-plus"></i>
      </span>
      Build Scenario
    </button>
  )
}

function EmptyGame({ sponsorView, isFilterEmpty = false }) {
  const navigate = useNavigate()

  const handleNewGameClick = () => {
    navigate(ROUTE_PATHS.GAME_ADD_NEW)
  }

  const handleBuildScenarioClick = () => {
    navigate(ROUTE_PATHS.SCENARIO_BUILD)
  }

  return (
    <section className="section-emptygame flex-center">
      <div className="game-wrapper">
        <div className="icon-wrapper">
          <i className="fa-solid fa-chess-rook"></i>
        </div>
        <div className="page-title">No Exercises Here!</div>
        {sponsorView ? (
          <>
            <div className="page-subtitle">
              {isFilterEmpty
                ? "Try modifying your filter parameters."
                : "You have not configured any exercises yet. Click the below button to add your first exercise."}
            </div>
            {!isFilterEmpty && (
              <div className="action-wrapper">
                <BuildScenarioButton onClick={handleBuildScenarioClick} />
                <button className="btn btn-primary btn-filled" onClick={handleNewGameClick}>
                  <span className="me-2">
                    <i className="fa-solid fa-plus"></i>
                  </span>
                  Add New Exercise
                </button>
              </div>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </section>
  )
}

export default EmptyGame
